import { render, staticRenderFns } from "./KanbanView.vue?vue&type=template&id=6a8044a1&scoped=true&"
import script from "./KanbanView.vue?vue&type=script&lang=js&"
export * from "./KanbanView.vue?vue&type=script&lang=js&"
import style0 from "./KanbanView.vue?vue&type=style&index=0&id=6a8044a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8044a1",
  null
  
)

export default component.exports